import React, { useState, useEffect } from "react";
import { FaDownload } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { Spinner as SpinnerBoot } from "react-bootstrap";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import Select from "react-select";

function Investigation() {
  const [investigationData, setInvestigationData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [uniqueNames, setUniqueNames] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState({ value: "all", label: "All" });
  const [isLoading, setIsLoading] = useState(false);
  const patientLogin = useSelector((state) => state.patient.patientLogin);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await SendPostRequest("healthcare/lab_reports", {
        user_id: patientLogin?.contact_num,
      });

      if (res?.data && Array.isArray(res.data)) {
        const names = [...new Set(res.data.map((item) => item?.patient_name))];
        const options = [{ value: "all", label: "All" }, ...names.map((n) => ({ value: n, label: n }))];
        setUniqueNames(options);
        setInvestigationData(res.data);
        setFilteredData(res.data);
      } else {
        setUniqueNames([{ value: "all", label: "All" }]);
        setInvestigationData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching investigations:", error);
      setUniqueNames([{ value: "all", label: "All" }]);
      setInvestigationData([]);
      setFilteredData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReportDownload = (reportUrl) => {
    window.open(reportUrl, "_blank");
  };

  // Filter by selected patient
  useEffect(() => {
    if (selectedPatient.value === "all") {
      setFilteredData(investigationData);
    } else {
      setFilteredData(
        investigationData.filter((patient) => patient.patient_name === selectedPatient.value)
      );
    }
  }, [selectedPatient, investigationData]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ced4da",
      borderRadius: "0.25rem",
      minHeight: "40px",
      fontSize: "0.875rem",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div className="Prescripition">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Investigation</h3>
        {isLoading ? (
          <SpinnerBoot />
        ) : (
          <div style={{ minWidth: "250px" }}>
            <Select
              options={uniqueNames}
              value={selectedPatient}
              onChange={(option) => setSelectedPatient(option)}
              styles={customStyles}
              isSearchable
              placeholder="Select a Patient..."
            />
          </div>
        )}
      </div>

      {isLoading ? (
        <div
          style={{ marginBottom: "60px" }}
          className="d-flex align-items-center justify-content-center "
        >
          <Spinner />
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table mt-2">
            <thead className="thead-light">
              <tr>
                <th scope="col">SR.NO</th>
                <th scope="col">Patient Name</th>
                <th scope="col">Service</th>
                <th scope="col">Report Status</th>
                <th scope="col">Report Date</th>
                <th scope="col">Report File</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="6">
                    <div className="prescription-rapper">No Record Available</div>
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={item?.uid}>
                    <td>{index + 1}</td>
                    <td>{item?.patient_name}</td>
                    <td>{item?.service_name}</td>
                    <td>{item?.report_status}</td>
                    <td>{item?.test_date}</td>
                    <td>
                      <button
                        className="download"
                        onClick={() => handleReportDownload(item?.report_url)}
                      >
                        <FaDownload />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Investigation;
